import {UnstyledButton, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import type {SortState} from './listingTypes';

interface SortableColumnHeaderProps {
  field: string;
  label: string;
  onSort: (field: string) => void;
  sort: SortState;
}

export default function SortableColumnHeader({
  field,
  label,
  onSort,
  sort,
}: SortableColumnHeaderProps): JSX.Element {
  const {classes, cx} = useStyles();
  const isActive = sort.field === field;

  const handleClick = (): void => {
    onSort(field);
  };

  return (
    <th>
      <UnstyledButton aria-label={`Sort by ${label}`} className={classes.button} onClick={handleClick}>
        {label}
        <BenchlingIcon
          className={cx(classes.icon, isActive ? classes.iconActive : classes.iconInactive)}
          icon={isActive ? (sort.direction === 'asc' ? 'arrow-up' : 'arrow-down') : 'arrow-up-down'}
        />
      </UnstyledButton>
    </th>
  );
}

const useStyles = createStyles((theme) => ({
  button: {
    alignItems: 'center',
    display: 'inline-flex',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    gap: 5,
    letterSpacing: 'inherit',
    textTransform: 'inherit' as const,
  },
  icon: {
    fontSize: 10,
  },
  iconActive: {
    color: theme.colors.blue[8],
  },
  iconInactive: {
    color: theme.colors.gray[4],
  },
}));
